<template>
  <v-app fluid>
    <router-view></router-view>
    <template v-if="announcement">
      <v-snackbar
        :multi-line="true"
        top="top"
        :timeout="20000"
        color="warning"
        :value=true
      >
        <div v-html="announcement"></div>
        <v-btn
          dark
          flat
          @click.native="closeAnnouncement()"
        >
          Close
        </v-btn>
      </v-snackbar>
    </template>
    <template v-if="error">
      <v-snackbar
        :multi-line="true"
        top="top"
        :timeout="6000"
        color="error"
        @input="closeError"
        :value="true"
      >
        <span v-html="error"></span>
        <v-btn
          dark
          flat
          @click.native="closeError"
        >
          Close
        </v-btn>
      </v-snackbar>
    </template>
    <template v-if="success">
      <v-snackbar
        :multi-line="true"
        :timeout="6000"
        top="top"
        color="success"
        @input="closeSuccess"
        :value="true"
      >
        {{ success }}
        <v-btn
          dark
          flat
          @click.native="closeSuccess"
        >
          Close
        </v-btn>
      </v-snackbar>
    </template>
  </v-app>
</template>

<script>
  export default {
    name: 'App',
    data() {
      return {
        announcementClose: false,
      }
    },
    metaInfo: {
      title: 'Package Shipping from the USA | Hotel4Box',
      htmlAttrs: {
        lang: 'en',
      }
    },
    created() {
      this.$http.interceptors.response.use(undefined, function (err) {
        return new Promise(function () {
          if (err.status === 401 && err.config && !err.config.__isRetryRequest) {
            this.$store.dispatch('removeUser')
          }
          throw err;
        });
      });
    },
    mounted() {
      if (localStorage.getItem('user')) {
        localStorage.removeItem('user')
      }

      if (localStorage.getItem('access_token') !== null && localStorage.getItem('access_token') !== 'undefined') {
        this.$store.commit('clearError')
        this.$store.commit('setLoading', true)
        if (this.$store.getters.getToken[0] === null && localStorage.getItem('access_token') != null) {
          this.$store.state.auth.access_token = localStorage.getItem('access_token')
        }
        if (this.$store.getters.getToken[1] === null && localStorage.getItem('refresh_token') != null) {
          this.$store.state.auth.refresh_token = localStorage.getItem('access_token')
        }
        this.$store.commit('setLoading', false)
      }
    },
    props: {
      source: String
    },
    methods: {
      closeError() {
        this.$store.dispatch('clearError')
      },
      closeSuccess() {
        this.$store.dispatch('clearSuccess')
      },
      closeAnnouncement() {
        this.announcementClose = true
      },
      loading() {
        return this.$store.getters.loading
      }
    },
    computed: {
      error() {
        return this.$store.getters.error
      },
      success() {
        return this.$store.getters.success
      },
      announcement() {
        if (parseInt(this.$store.getters.getSettings.show_announcement) && !this.announcementClose) {
          return this.$store.getters.getSettings.announcement_text
        }
        return false;
      }
    }
  }
</script>

<style lang="stylus">

  @import "sccs/_form.styl"
  @import "sccs/_tooltip.styl"
  @import "sccs/_common.styl"
  @import "sccs/_tracking.styl"

  body
    max-width 100%
    align-self center

  a
    text-decoration none

  .btn-default-text
    text-transform none !important

  .pointer
    cursor pointer

  .main-block
    background-color white
    max-width 100%

  .w-100
    width 100%

  .sign-in
    height 32px
    width 100%
    color #2F343D
    font-family Signika
    font-size 24px
    font-weight bold
    line-height 32px

  .create-account
    height: 20px
    min-width: 110px
    color: #0E97FF
    font-family: "Open Sans"
    font-size: 13px
    font-weight: 600
    line-height: 20px

  .rectangle-login
    height 44px
    width 154px
    flex inherit
    border-radius 6px
    background-color #0E97FF

  .registration-login
    height 20px
    width 94px
    color #FFFFFF
    font-family "Open Sans"
    font-size 16px
    font-weight 600
    line-height 20px

  .sign-in-btn
    height 44px
    max-width 100%
    border-radius 6px
    background-color #0E97FF

  .text-field-sign-in
    height 52px
    border 1px solid #BDC4C9
    border-radius 6px

  input
    outline none

  input:-webkit-autofill
    -webkit-box-shadow inset 0 0 0 50px #fff !important

  .pac-container
    //margin-left -12px
    min-width calc(30% - 0.3em)

  .pac-container:empty
    display none !important

  .v-menu__content
    margin-top 52px

  .v-autocomplete__content
    margin-top 0

  .other-information .v-input__control
    margin-top 2px !important

  /*.text-field-sign-in*/
  /*cursor not-allowed*/
  /*background-color gainsboro !important*/
  .disable-select
    cursor not-allowed !important
    background-color gainsboro

  .disable-select .v-input__slot
    cursor not-allowed !important
    background-color gainsboro !important

  .disable-select input
    cursor not-allowed !important

  .icon-img-toolbar
    height 14px
    width 14px

  .phone-fields .dropdown ul
    z-index 1

  .v-snack--multi-line .v-snack__content
    height auto !important

  .v-label--active
    top 10px !important

  .v-text-field--box input, .v-text-field--full-width input, .v-text-field--outline input
    margin-top 14px !important

  .v-text-field--box > .v-input__control > .v-input__slot, .v-text-field--full-width > .v-input__control > .v-input__slot, .v-text-field--outline > .v-input__control > .v-input__slot
    min-height 40px !important
    margin-bottom 2px !important

  .text-switch
    color #008EFF
    font-family Roboto
    font-size 18px
    font-weight bold
    line-height 28px

  .text-type-disable
     color #000 !important
     opacity 0.4

  .word-wrap-md
    word-wrap break-word !important
    max-width 300px !important

</style>
